import { Component, h, Prop } from '@stencil/core';
import { Cart } from '../../../redux/types';
import { TotalPriceCalculation } from '../../../types/types';
import { t } from '../../../redux/utils';
import rentwareIcon from '../../../types/icons';
import ArrowDown from '../../atoms/svg-elements/arrow-down';
import { PickerDate } from '../../rtr-article-details/utils/types';

@Component({
  tag: 'rentware-cart-control-button-details',
  styleUrl: 'style.sass',
  shadow: true,
})
export class RentwareCartControlButtonDetails {
  @Prop() pickerDate: PickerDate;
  @Prop() onToggleCart: () => void;
  @Prop() cart: Cart;

  get totalText() {
    if (this.cart?.totalQuantityWithShipping === 1) {
      return '1 ' + t('cart.articleInCart');
    }

    return this.cart?.totalQuantityWithShipping + ' ' + t('cart.articlesInCart');
  }

  get cartShownPrice() {
    if (this.cart?.totalPriceCalculation === TotalPriceCalculation.Interval) {
      return this.cart?.discountedPriceWithoutDeposit;
    }

    if (this.cart?.totalPriceCalculation === TotalPriceCalculation.Month) {
      return this.cart?.discountedPricePerMonthWithoutDeposit;
    }
  }

  get totalPrice() {
    return <rentware-total-price price={this.cartShownPrice} showTotalText={true} />;
  }

  render() {
    if (!this.cart) {
      return null;
    }

    return (
      <div class="CartDetailsContainer" onClick={this.onToggleCart} tabIndex={0}>
        <div class="CartDetailsInfo">
          <rtr-date-info-short pickerDate={this.pickerDate} />
          <div class="CartDetailsArticle">
            <div>{rentwareIcon('iconCartWagon')}</div>
            {this.totalText}
          </div>
        </div>

        <div class="CartDetailsPriceContainer">
          <div class="CartDetailsPrice">
            {this.totalPrice}
            {this.cart.depositPrice?.gross > 0 && (
              <span>
                <rentware-deposit-price price={this.cart.depositPrice} />
              </span>
            )}
          </div>
          <ArrowDown />
        </div>
      </div>
    );
  }
}
